import React from "react";

const AlertMessage = (props) => {
  return (
    <div
      className="alertMessage"
      style={{ background: props.background, margin: props.margin }}
    >
      <img
        className="alertMessage__icono"
        src={props.icono}
        alt="icono de alerta"
      />
      <p className="alertMessage__mensaje">{props.mensaje}</p>
    </div>
  );
};

export default AlertMessage;
